import { isDevelopment, isProduction, isTest } from 'config/env';
import { UK_LANGUAGE } from 'languages';
import { useRouter } from 'next/router';
import { useCheckPlug } from 'utils/CheckPlug';

export const useLink = () => {
  let linkEnv = '';

  const { locale = '' } = useRouter();

  const bhubModule = useCheckPlug();

  if (isTest) {
    linkEnv = `http://localhost:3000${
      locale === UK_LANGUAGE ? '' : `/${locale}`
    }/${bhubModule}`;
  } else if (isDevelopment) {
    linkEnv = `https://dev.pro.bhub.com.ua${
      locale === UK_LANGUAGE ? '' : `/${locale}`
    }/${bhubModule}`;
  } else if (isProduction) {
    linkEnv = `https://pro.bhub.com.ua${
      locale === UK_LANGUAGE ? '' : `/${locale}`
    }/${bhubModule}`;
  }

  return linkEnv;
};
